
import React, { PropTypes } from 'react';

export class ShutEye extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  };

  render () {
    const fill = this.props.colorSchema === 'primary'
      ? '#00587c'
      : '#000000';

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width || '25'}
        height={this.props.height || '20'}
        viewBox="0 0 25 20"
      >
        <path d={'M24.883 18.9545L0.898591 0.0677435C0.83388 0.0160266 0.751283 -0.00788105 ' +
          '0.668952 0.00127491C0.586622 0.0104309 0.511295 0.0519012 0.459528 ' +
          '0.116572L0.0689031 0.605244C0.0171423 0.669906 -0.00683069 0.752472 ' +
          '0.00225174 0.8348C0.0113342 0.917127 0.052729 0.992482 0.117341 ' +
          '1.04431L24.1017 19.931C24.1338 19.9567 24.1706 19.9758 24.21 19.9872C24.2494 ' +
          '19.9987 24.2907 20.0022 24.3316 19.9977C24.3724 19.9932 24.4119 19.9806 24.4479 ' +
          '19.9608C24.4838 19.941 24.5155 19.9143 24.5412 19.8822L24.9318 19.3935C24.9835 ' +
          '19.3288 25.0074 19.2462 24.9983 19.1639C24.9891 19.0816 24.9476 19.0062 24.883 ' +
          '18.9545ZM12.5002 3.74938C13.8258 3.75083 15.0967 4.27808 16.0341 5.21545C16.9715 ' +
          '6.15282 17.4987 7.42375 17.5002 8.74938C17.5002 9.59391 17.2697 10.3779 16.8986 ' +
          '11.0763L17.8927 11.8576C18.424 10.9404 18.7502 9.88767 18.7502 8.74938C18.7502 ' +
          '7.31071 18.2459 6.0029 17.4306 4.94743C19.6148 6.05007 21.3911 7.81952 22.5021 ' +
          '9.99938C21.8381 11.2884 20.9405 12.4429 19.8548 13.4041L20.8439 14.183C21.956 ' +
          '13.1564 22.9091 11.9463 23.6146 10.5693C23.704 10.3925 23.7505 10.1973 23.7505 ' +
          '9.99919C23.7505 9.80112 23.704 9.60583 23.6146 9.42907C21.4962 5.29587 17.3025 ' +
          '2.49938 12.5002 2.49938C10.7456 2.49845 9.01163 2.87731 7.41734 3.60993L9.20523 ' +
          '5.01618C10.0877 4.23845 11.233 3.74938 12.5002 3.74938ZM14.8775 9.48493C14.9999 ' +
          '9.11179 15.0315 8.71481 14.9696 8.32702C14.9076 7.93922 14.754 7.57181 14.5215 ' +
          '7.25534C14.289 6.93887 13.9843 6.68249 13.6327 6.50752C13.2811 6.33256 12.8928 ' +
          '6.24406 12.5002 6.24938C12.4611 6.24938 12.4263 6.25876 12.3888 6.26071C12.5404 ' +
          '6.66674 12.5371 7.11441 12.3794 7.51813L14.8775 9.48493ZM6.37672 7.56462C6.2955 ' +
          '7.95439 6.2531 8.35125 6.25015 8.74938C6.24614 9.79654 6.5063 10.8278 7.00657 ' +
          '11.7477C7.50684 12.6677 8.23105 13.4466 9.1122 14.0123C9.99335 14.5781 11.003 ' +
          '14.9126 12.0476 14.9846C13.0923 15.0567 14.1383 14.8642 15.0888 14.4248L13.9334 ' +
          '13.515C13.4763 13.6529 13.0017 13.7494 12.5005 13.7494C11.1749 13.7479 9.9039 ' +
          '13.2207 8.96647 12.2833C8.02904 11.346 7.5017 10.0751 7.50015 8.74938C7.50015 ' +
          '8.65407 7.5232 8.56501 7.52828 8.47126L6.37672 7.56462ZM12.5002 16.2494C8.3064 ' +
          '16.2494 4.47398 13.8545 2.50015 9.99938C3.18101 8.67126 4.10523 7.54938 5.16851 ' +
          '6.61188L4.15836 5.81618C3.04586 6.84274 2.09312 8.05251 1.38765 9.42946C1.29829 ' +
          '9.60622 1.25174 9.80152 1.25174 9.99958C1.25174 10.1976 1.29829 10.3929 1.38765 ' +
          '10.5697C3.50445 14.7029 7.6982 17.4994 12.5002 17.4994C14.2547 17.5003 15.9887 ' +
          '17.1214 17.583 16.3888L16.4404 15.4904C15.1978 15.9697 13.8732 16.2494 12.5002 ' +
          '16.2494Z'}
          fill={fill} />
      </svg >
    );
  }
}

export default ShutEye;



/** WEBPACK FOOTER **
 ** ./src/components/svg/shut-eye.js
 **/